import { indexOf } from 'lodash';
import * as React from 'react'
import { monthsWithOverview as months } from 'services/centralStore';
type Month = { name: string, selected: boolean };
export type InitialStateType = {[key: string]: Month}
type SelectedMonthActionType = {type: 'SET_ACTIVE_MONTH', selectedMonthName?: string}

const initialState: InitialStateType = {};
let selectedIndex = new Date().getMonth() + 1;
selectedIndex = selectedIndex > 11 ? 0 : selectedIndex;
const selectedMonth = months[selectedIndex];
months.forEach(month => {
    initialState[month] = {name: month, selected: month === selectedMonth}
})

const selectedMonthReducer = (state: InitialStateType, action: SelectedMonthActionType) => {
    switch(action.type) {
        case 'SET_ACTIVE_MONTH':
            const newState = {...initialState}
            let month: keyof InitialStateType;
            for (month in newState) {
                if (newState[month].name === action.selectedMonthName) {
                    newState[month].selected = true
                } else {
                    newState[month].selected = false
                }
            }
            return newState;
        default:
            return state
    }
}

const selectedMonthContext = React.createContext<[InitialStateType, Function]>([initialState, (): void => undefined])

export const SelectedMonthProvider = ({children}: {children: React.ReactNode}) => {
    return(<selectedMonthContext.Provider value={React.useReducer(selectedMonthReducer, initialState )}>
        {children}
    </selectedMonthContext.Provider>)
}

export const useSelectedMonthContext = () => React.useContext(selectedMonthContext)

export const getActiveMonth = (months: InitialStateType) : Month => {
    let month
    let x: keyof InitialStateType
    for (x in months) {
        if(months.hasOwnProperty(x)) {
            if (months[x].selected) month = months[x]
        }
    }
    return month
}

export const getMonthIndexFromName = (month: string): number => {
    let idx = months.indexOf(month);
    if (idx < 0 || idx == null) {
        return null;
    }
    return idx;
}